namespace RioERP.Reports {
    @Serenity.Decorators.registerClass()
    export class OrderShippingReportDialog extends Serenity.EntityDialog<OrderShippingReportRow, any> {
        protected getFormKey() { return OrderShippingReportForm.formKey; }
        protected getIdProperty() { return OrderShippingReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderShippingReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderShippingReportRow.nameProperty; }
        protected getService() { return OrderShippingReportService.baseUrl; }
        protected getDeletePermission() { return OrderShippingReportRow.deletePermission; }
        protected getInsertPermission() { return OrderShippingReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderShippingReportRow.updatePermission; }

        protected form = new OrderShippingReportForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.push({
                title: Q.text('Add Book'),
                cssClass: 'bg-olive',
                separator: true,
                icon: 'fa-solid fa-book',
                onClick: () => {

                    let orderId = this.form.OrderNumber.value;
                    this.openAddBookDialog(orderId); // Pass orderId here


                }
            });

            return buttons;
        }

        private openAddBookDialog(orderId: string) {
            let dlg = new AddBookDialog(orderId); // Pass orderId to dialog constructor
            dlg.loadEntityAndOpenDialog(this.get_entityId());
        }
    }
}
